import styled from 'styled-components'

export const OrderDayCounterWrapper = styled.div`
	&.cancelled {
		text-decoration: line-through;
	}
`
OrderDayCounterWrapper.displayName = 'OrderDayCounterWrapper'
